import { useEffect, useState } from "react";
import { API } from "@/lib/api";
import axios from "axios";

// Module-level cache so multiple components sharing the same slot don't refetch.
const CACHE = new Map();
const IN_FLIGHT = new Map();

/**
 * Fetch the CMS-managed image URL for a named slot.
 * Returns { url, alt_text, loading }. Falls back to the provided `fallback`
 * URL until the fetch resolves (or if it fails).
 */
export default function useSiteImage(slot, fallback = "") {
  const cached = CACHE.get(slot);
  const [data, setData] = useState(cached || null);

  useEffect(() => {
    if (!slot) return;
    if (CACHE.has(slot)) {
      setData(CACHE.get(slot));
      return;
    }
    let cancelled = false;
    let promise = IN_FLIGHT.get(slot);
    if (!promise) {
      promise = axios
        .get(`${API}/cms/site-images/slot/${slot}`)
        .then((r) => r.data)
        .catch(() => null)
        .finally(() => IN_FLIGHT.delete(slot));
      IN_FLIGHT.set(slot, promise);
    }
    promise.then((row) => {
      if (cancelled) return;
      if (row) CACHE.set(slot, row);
      setData(row);
    });
    return () => {
      cancelled = true;
    };
  }, [slot]);

  return {
    url: data?.url || fallback,
    alt_text: data?.alt_text || "",
    loading: !data && !CACHE.has(slot),
  };
}
